export const VALUES = {
  addOrRemoveReaction: 'Add or remove reactions',
  reactionsUnavailable: 'Reactions are currently unavailable',
  copilotDisplayName: 'Copilot',
}
